import { useCreateSupportConversationMutation } from "@/app/chat/chat.api";
import { Button } from "@/shared/components/atoms/Button";
import { FAQEntry } from "@/shared/components/molecules/FAQEntry";
import { faUserHeadset } from "@fortawesome/pro-regular-svg-icons";
import React, { useEffect, useMemo, type FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export type FAQPageProps = {};

export const FAQPage: FC<FAQPageProps> = () => {
  const [t] = useTranslation();
  const navigate = useNavigate();

  const [createSupportConversation, createSupportConversationResult] =
    useCreateSupportConversationMutation();

  const questions = useMemo(
    () =>
      t("questions.views.questions", {
        returnObjects: true,
      }) as Array<any>,
    [t]
  );

  useEffect(() => {
    if (createSupportConversationResult.isSuccess) {
      navigate("/chat?support=1");
    }
  }, [createSupportConversationResult]);

  const handleContact = () => {
    createSupportConversation(undefined);
  };

  return (
    <section className="py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-16">
          <h2 className="text-4xl text-primary font-manrope text-center font-bold text-gray-900 leading-[3.25rem]">
            {t("questions.views.support")}
          </h2>
        </div>
        <div className="flex flex-col gap-4">
          {questions.map((question) => (
            <FAQEntry key={question.id} title={question.title} content={question.description} />
          ))}
          <div className="flex flex-col items-center justify-center gap-2">
            <p>{t("questions.views.not_answered")}</p>
            <Button
              primary
              text="Contact us"
              iconRight={faUserHeadset}
              onClick={handleContact}
              isLoading={createSupportConversationResult.isLoading}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
